import { createFileRoute } from "@tanstack/react-router";
import { Fragment, type CSSProperties } from "react";
import { GoButton } from "../../components/GoButton";
import { createPixelScaleVars } from "@/lib/utils";
import {
  PixelOnboardingScene,
  PIXEL_ONBOARDING_CANVAS_HEIGHT,
  PIXEL_ONBOARDING_GROUND_HEIGHT,
} from "@/components/PixelOnboardingScene";
import { PixelOnboardingLogo } from "@/components/PixelOnboardingLogo";
import { PixelOnboardingClouds } from "@/components/PixelOnboardingClouds";

export const Route = createFileRoute("/onboarding/")({
  component: Onboarding,
});

function Onboarding() {
  const groundTextureUrl = "https://cdn.navalabs.io/ground_cip0le.png";

  const pixelScaleStyles = createPixelScaleVars({
    idealViewportWidth: 1280,
    minViewportWidth: 320,
    maxViewportWidth: 1440,
  }) as CSSProperties;

  const canvasScaleExpression = `min(100vh, ${PIXEL_ONBOARDING_CANVAS_HEIGHT}px) / ${PIXEL_ONBOARDING_CANVAS_HEIGHT}px`;

  const backgroundStyles: CSSProperties = {
    backgroundImage: `url('${groundTextureUrl}')`,
    backgroundRepeat: "repeat-x",
    backgroundPosition: "bottom center",
    backgroundSize: `auto calc(${PIXEL_ONBOARDING_GROUND_HEIGHT}px * (${canvasScaleExpression}))`,
    imageRendering: "pixelated",
  };

  return (
    <Fragment>
      <div
        className="relative flex flex-1 flex-col items-center justify-between bg-[#29ADFF]"
        style={{ ...pixelScaleStyles, ...backgroundStyles }}
      >
        <PixelOnboardingClouds
          className="absolute inset-0 z-[4]"
          scaleExpression={canvasScaleExpression}
        />
        <div
          aria-hidden
          className="pointer-events-none absolute inset-x-0 bottom-0 z-[9]"
          style={{
            height: `calc(${PIXEL_ONBOARDING_GROUND_HEIGHT}px * (${canvasScaleExpression}))`,
            backgroundImage: `url('${groundTextureUrl}')`,
            backgroundRepeat: "repeat-x",
            backgroundPosition: "bottom center",
            backgroundSize: `auto calc(${PIXEL_ONBOARDING_GROUND_HEIGHT}px * (${canvasScaleExpression}))`,
            imageRendering: "pixelated",
          }}
        />
        <PixelOnboardingLogo
          className="absolute left-1/2 top-1/8 z-20 -translate-x-1/2 -translate-y-1/2"
          scaleExpression={canvasScaleExpression}
        />
        <PixelOnboardingScene
          className="absolute bottom-0 left-1/2 z-10 -translate-x-1/2"
          scaleExpression={canvasScaleExpression}
        />
        {/*<div className="px-4 mt-4 flex flex-col gap-1 min-h-fit">
          <div className="space-y-1 mb-2 text-center">
            <h2 className="text-white text-base xs:text-xl font-semibold">
              Welcome to CFL!
            </h2>
            <p className="text-[#d4d4d8] text-sm">
              Become the manager of your token squad!
            </p>
          </div>
        </div>
        <GoButton />*/}
        <div
          className="z-4 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 animate-[pixel-logo-pulse_1s_ease-in-out_infinite]"
          style={{
            animationDelay: `2400ms`,
            animationTimingFunction: `steps(2, end)`,
          }}
        >
          <GoButton />
        </div>
      </div>
    </Fragment>
  );
}
